import { createSelector } from '@reduxjs/toolkit';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectApiStatusForInputs } from './_redux-inputs';

export const selectIsProjectWaitingOnRequests = createSelector([
    (state: GiftPdpState) => state.snapshot.pushStatus,
    (state: GiftPdpState) => state.projectLoading.loadStatus,
    (state: GiftPdpState) => state.auth.authStatus,
    (state: GiftPdpState) => selectApiStatusForInputs(state)
], (pushStatus, loadStatus, authStatus, inputStatus) => {
    return [pushStatus, loadStatus, authStatus, inputStatus].includes('pending');
});

export const selectHasError = createSelector([
    (state: GiftPdpState) => selectApiStatusForInputs(state)
], (inputStatus) => {
    return [inputStatus].includes('error');
});